import React, { memo, useState, useCallback, useMemo } from "react";
import Accordion from "../../components/accordion";
import { FaComments, FaEye } from "react-icons/fa";
import { TableListing } from "../../components/AppListing/TableListing";
import MainPageDialog from "../../components/dialog";
import moment from "moment";

const PatientAllergy = memo(
  ({
    allergies,
    showDetails = true,
    showDialogue = false,
    rightDialogHandler = () => {},
  }) => {
    const [dialogState, setDialogState] = useState({
      open: false,
      comments: "",
    });

    const handleAllergyComments = useCallback((data) => {
      setDialogState({
        open: true,
        comments: data?.comments || "",
      });
    }, []);

    const closeDialog = useCallback(() => {
      setDialogState((prevState) => ({
        ...prevState,
        open: false,
      }));
    }, []);

    const AllergiesCols = useMemo(
      () => [
        { title: "Allergy", key: "name", colClass: "flex text-left" },
        {
          title: "Type",
          key: "allergen_type",
          colClass: "flex text-left",
          getData: (item) =>
            item?.allergen_type ? (
              <div className="capitalize">
                {item.allergen_type.replace(/_/g, " ")}
              </div>
            ) : (
              "-"
            ),
        },
        { title: "Reaction", key: "reaction", colClass: "flex text-left" },
        {
          title: "Severity",
          key: "severity",
          colClass: "flex text-left",
          getData: (item) =>
            item?.severity ? (
              <div className="capitalize">
                {item.severity.replace(/_/g, " ")}
              </div>
            ) : (
              "-"
            ),
        },
        {
          title: "Onset",
          key: "onset_date",
          colClass: "flex text-left",
          getData: (data) => {
            const originalDate =
              data?.onset_date !== ""
                ? moment(data.onset_date).format("l")
                : "";
            return originalDate;
          },
        },
        {
          title: "Comments",
          key: "history",
          colClass: "flex text-left",
          colClass: "col-md-1 text-center",
          getData: (item) =>
            item?.comments && (
              <div className="flex w-[100%] items-start justify-start px-2 text-blue-500 text-lg hover:text-blue-900">
                <FaComments />
              </div>
            ),
          onClick: handleAllergyComments,
        },
      ],
      [handleAllergyComments]
    );

    return (
      <div>
        <Accordion
          title="Allergies"
          open={true}
          showCount={true}
          count={allergies?.length || 0}
          showDialogue={showDialogue}
          rightDialogHandler={rightDialogHandler}
          icon={<FaEye className="text-blue-500" />}
        >
          {dialogState.open && (
            <MainPageDialog
              title="Comments"
              modalSize="md"
              maxHeight={true}
              footerList={[
                {
                  title: "Cancel",
                  type: "cancel",
                  action: closeDialog,
                },
              ]}
              onCancelHandler={closeDialog}
            >
              {dialogState.comments === ""
                ? "No comments added."
                : dialogState.comments}
            </MainPageDialog>
          )}
          {showDetails ? (
            <TableListing
              loading={false}
              listData={allergies || []}
              cols={AllergiesCols}
            />
          ) : (
            <div className="flex flex-col gap-1">
              {allergies?.length > 0 ? (
                allergies?.map((item, index) => (
                  <div key={index} className={`flex items-flex-start text-left border-b border-gray-200 ${index%2 === 0 ? 'bg-gray-100' : ''}`}>
                    <p className="text-sm p-2">{index + 1}. {item?.name}</p>
                  </div>
                ))
              ) : (
                <div>
                  <p>
                    <strong>No Allergies Found</strong>
                  </p>
                </div>
              )}
            </div>
          )}
        </Accordion>
      </div>
    );
  }
);

export default PatientAllergy;